module.exports = __webpack_public_path__ + "static/media/valyrian-steel-blade-token.940de262.png";